import request from '@/util/request'

const state = {
  infoTooltips: JSON.parse(sessionStorage.getItem('infoTooltips')) || [],
  activeTooltip: '',
}
const getters = {
  infoTooltips: state => state.infoTooltips,
  activeTooltip: state => state.activeTooltip,
}
const actions = {
  loadTooltips({ commit, dispatch }) {
    return request({
      url: '/tooltip',
      method: 'get',
    }).then(resp => {
      const tooltips = resp.tooltips.filter(item => item.too_aktyvus)
      commit('SET_TOOLTIPS', tooltips)
    })
  },
  activeTooltip({ commit }, payload) {
    commit('SET_ACTIVE_TOOLTIP', payload)
  },
}
const mutations = {
  SET_TOOLTIPS(state, payload) {
    state.infoTooltips = payload
    sessionStorage.setItem('infoTooltips', JSON.stringify(payload))
  },
  SET_ACTIVE_TOOLTIP(state, payload) {
    state.activeTooltip = payload
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
